export const US_STATES = [
  {  name: "Alabama", shortName: "AL"},
  {  name: "Alaska", shortName: "AK"},
  { name: "Arkansas", shortName: "AR" },
  { name: "Arizona", shortName: "AZ" },
  { name: "California", shortName: "CA" },
  { name: "Colorado", shortName: "CO" },
  { name: "Connecticut", shortName: "CT" },
  { name: "District of Columbia", shortName: "DC" },
  { name: "Delaware", shortName: "DE" },
  { name: "Florida", shortName: "FL" },
  { name: "Georgia", shortName: "GA" },
  { name: "Hawaii", shortName: "HI" },
  { name: "Iowa", shortName: "IA" },
  { name: "Idaho", shortName: "ID" },
  { name: "Illinois", shortName: "IL" },
  { name: "Indiana", shortName: "IN" },
  { name: "Kansas", shortName: "KS" },
  { name: "Kentucky", shortName: "KY" },
  { name: "Louisiana", shortName: "LA" },
  { name: "Massachusetts", shortName: "MA" },
  { name: "Maryland", shortName: "MD" },
  { name: "Maine", shortName: "ME" },
  { name: "Michigan", shortName: "MI" },
  { name: "Minnesota", shortName: "MN" },
  { name: "Missouri", shortName: "MO" },
  { name: "Mississippi", shortName: "MS" },
  { name: "Montana", shortName: "MT" },
  { name: "North Carolina", shortName: "NC" },
  { name: "North Dakota", shortName: "ND" },
  { name: "Nebraska", shortName: "NE" },
  { name: "New Hampshire", shortName: "NH" },
  { name: "New Jersey", shortName: "NJ" },
  { name: "New Mexico", shortName: "NM" },
  { name: "Nevada", shortName: "NV" },
  { name: "New York", shortName: "NY" },
  { name: "Ohio", shortName: "OH" },
  { name: "Oklahoma", shortName: "OK" },
  { name: "Oregon", shortName: "OR" },
  { name: "Pennsylvania", shortName: "PA" },
  { name: "Rhode Island", shortName: "RI" },
  { name: "South Carolina", shortName: "SC" },
  { name: "South Dakota", shortName: "SD" },
  { name: "Tennessee", shortName: "TN" },
  { name: "Texas", shortName: "TX" },
  { name: "Utah", shortName: "UT" },
  { name: "Virginia", shortName: "VA" },
  { name: "Vermont", shortName: "VT" },
  { name: "Washington", shortName: "WA" },
  { name: "Wisconsin", shortName: "WI" },
  { name: "West Virginia", shortName: "WV" },
  { name: "Wyoming", shortName: "WY" }
];
